import { useState } from "react";
import { verifyBooleanValue } from "@core/utils/varifyBooleanValue";

import { SwitchProps } from "./types";

export function useSwitch({ value }: SwitchProps) {
  const [showInstructions, setShowInstructions] = useState(false);
  const checked = verifyBooleanValue(value);

  const handleClickShowInstructions = () => {
    setShowInstructions(!showInstructions);
  };

  return {
    checked,
    showInstructions,
    setShowInstructions,
    handleClickShowInstructions
  };
}
